module.exports = __webpack_public_path__ + "media/img/cart-working-d527208f7708a3340e39af563dde9da3.png";